import { Component, Input, OnDestroy } from '@angular/core';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { MessageService } from '@services/message.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-message-box',
    templateUrl: './message-box.component.html',
    styleUrls: ['./message-box.component.scss'],
    standalone: false
})
export class MessageBoxComponent implements OnDestroy {
    @Input() center: boolean;

    public message: string;
    public type: string;
    public show = false;

    private messageSubscription: Subscription;
    private hideTimeout: ReturnType<typeof setTimeout>;

    constructor(
        private readonly messageService: MessageService,
        private readonly router: Router
    ) {
        this.messageSubscription = this.messageService
            .message$
            .subscribe((options) => {
                if (options) {
                    this.type = options.type;
                    this.message = options.message;
                    this.show = true;

                    // Toast: hides by itself so it does not stay on the next pages
                    clearTimeout(this.hideTimeout);
                    this.hideTimeout = setTimeout(() => this.close(), 5000);
                }
            });

        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.messageService.clear();
            }
        });
    }

    public close() {
        this.show = false;
    }

    ngOnDestroy() {
        clearTimeout(this.hideTimeout);
        this.messageSubscription.unsubscribe();
    }
}
